import React, { ReactElement, useEffect } from 'react';
import { INVENTORY_HEALTHCHECK_NESTED_ROUTE_DETAIL } from '../../../config/route/NestedRoutesConfig';
import NestedRoute from '../../../shared/components/tabs/NestedRoute';
import { FETCH_INVENTORY_DASHBOARD } from '../../../shared/constants/urlEndPoints';
import { dashBoardRequest } from '../../../store/actions/leftSideBarAction';
import { getMappedRoute } from '../../../utils/routeUtility';
import { useDispatch } from 'react-redux';
import { INVENTORY_MESSAGE_CONSTANTS, PACKAGE_TYPE } from './../../../shared/constants/commonConstants';

const HealthCheck = ({ match, location }: any): ReactElement => {
  const nextDefaultPage = getMappedRoute(location?.pathname, INVENTORY_HEALTHCHECK_NESTED_ROUTE_DETAIL)
    || INVENTORY_HEALTHCHECK_NESTED_ROUTE_DETAIL[0].routeName;
  const dispatch = useDispatch();
  useEffect((): void => {
    dispatch(dashBoardRequest({
      title: INVENTORY_MESSAGE_CONSTANTS.title.healthCheckPackages,
      url: `${process.env.REACT_APP_INVENTORY_API_BASE_URL}${FETCH_INVENTORY_DASHBOARD}`, type: PACKAGE_TYPE.HEALTHCHECK,
    }));
    // eslint-disable-next-line
  }, []);

  return (
    <div className="hc">
      <NestedRoute
        match={match}
        defaultPage={nextDefaultPage}
        nestedNav={INVENTORY_HEALTHCHECK_NESTED_ROUTE_DETAIL} />
    </div>
  );
};

export default HealthCheck;
